"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBadge = exports.Badge = exports.BADGE_COLOR = void 0;
var React = _interopRequireWildcard(require("react"));
var _color = require("../../styles/variables/_color");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _Text = require("../Text");
var _BadgeModule = _interopRequireDefault(require("./Badge.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const BADGE_COLOR = Object.freeze({
  gray: _color.colorGrayLightest,
  red: _color.colorDangerLightest,
  redDark: _color.colorDanger,
  orange: _color.colorWarningLightest,
  orangeDark: _color.colorWarning,
  green: _color.colorSuccessLightest,
  greenDark: _color.colorSuccess,
  blue: _color.colorInformationLightest,
  blueDark: _color.colorInformation,
  indigo: _color.colorNeutralLightest,
  indigoDark: _color.colorNeutral
});
exports.BADGE_COLOR = BADGE_COLOR;
const Badge = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    text,
    fill = 'gray'
  } = _ref;
  const isDark = fill.includes('Dark');
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "Badge",
    style: {
      '--wrapperBgColor': BADGE_COLOR[fill]
    },
    className: (0, _classify.default)(_BadgeModule.default.badgeWrapper, {
      [_BadgeModule.default.fixedWidth]: text.length <= 2
    }, classNames?.wrapper),
    ref: ref
  }, /*#__PURE__*/React.createElement(_Text.ButtonTextSmall, {
    className: (0, _classify.default)({
      [_BadgeModule.default.dark]: isDark,
      [_BadgeModule.default.light]: !isDark
    }, classNames?.text)
  }, text));
});
exports.Badge = Badge;
const IconBadge = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    classNames,
    fill = 'gray',
    iconName,
    iconSize = 'small',
    iconType = 'solid',
    ariaLabel,
    onClick
  } = _ref2;
  const isDark = fill.includes('Dark');
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "Badge",
    style: {
      '--wrapperBgColor': BADGE_COLOR[fill]
    },
    className: (0, _classify.default)(_BadgeModule.default.badgeWrapper, _BadgeModule.default.iconContainer, classNames?.wrapper),
    ref: ref
  }, /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconName,
    type: iconType,
    size: iconSize,
    ariaLabel: ariaLabel,
    onClick: onClick,
    className: (0, _classify.default)({
      [_BadgeModule.default.dark]: isDark,
      [_BadgeModule.default.light]: !isDark
    }, classNames?.icon)
  }));
});
exports.IconBadge = IconBadge;